const LangEgiftShoppingCart = {
	"egiftShoppingCart.shoppingCart": ["Shopping Cart", "Giỏ Hàng"],
	"egiftShoppingCart.egift": ["E-Gift", "Quà tặng điện tử"],
	"egiftShoppingCart.recipient": ["Recipient", "Người nhận"],
	"egiftShoppingCart.amount": ["Amount", "Số tiền"],
	"egiftShoppingCart.youHaveSelected": [
		"You have selected ${subDepartmentCode} card",
		"Bạn đã chọn thẻ ${subDepartmentCode}",
	],
	"egiftShoppingCart.yourMessageTo": [
		"Your Message to ${toName}",
		"Tin  nhắn bạn gửi đến ${toName}",
	],
	"egiftShoppingCart._termOfUseLink": [
		"https://en.starbucks.vn/about-us/company-information/online-policies/starbucks-egift-terms-and-conditions",
		"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C3%B4ng-ty/ch%C3%ADnh-s%C3%A1ch-tr%E1%BB%B1c-tuy%E1%BA%BFn/starbucks-egift-terms-and-conditions",
	],
}

export default LangEgiftShoppingCart



// WEBPACK FOOTER //
// ./src/resources/pages/LangEgiftShoppingCart.js